import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PasswordResetRequest } from '../models/user.requests';
import { PasswordConfirmationError } from '../models/user.errors';
import { environment } from '../../../../environments/environment';
import { APIRoutes } from '../../../shared/constants/api-routes.constant';
import { HttpInterceptor } from '../../../shared/interceptors/http-interceptor.service';
import { ChangePasswordModel } from '../models/change-password.model';
import { AuthenticatedWebService } from '../../../shared/services/authenticated.web.service';
import { OAuthService } from './oauth.service';
import { map } from 'rxjs/operators';
import { HttpHeaders } from '@angular/common/http';

@Injectable()
export class RecoveryService extends AuthenticatedWebService {
  private headers_no_auth: HttpHeaders;

  constructor(
    private http: HttpInterceptor,
    oauthService: OAuthService
  ) {
    super(oauthService);
    this.headers_no_auth = new HttpHeaders({
      'Content-Type': 'application/json',
    });
  }

  requestRecovery(email: string): Observable<any> {
    if (!email) throw new Error('Email is required');
    let data = { email: email };
    return this.http
      .post(environment.api.base_api + APIRoutes.FORGOT_PASSWORD, data, {
        headers: this.headers_no_auth,
      })
      .pipe(map((res: any) => res));
  }

  resetPassword(
    token: string,
    email: string,
    pw: string,
    pwConfirm: string
  ): Observable<any> {
    if (pw != pwConfirm) {
      throw new PasswordConfirmationError('Invalid password.');
    }
    let data: PasswordResetRequest = new PasswordResetRequest(
      token,
      email,
      pw,
      pwConfirm
    );
    return this.http
      .post(environment.api.base_api + APIRoutes.RESET_PASSWORD, data, {
        headers: this.headers_no_auth,
      })
      .pipe(map((res: any) => res));
  }

  changePassword(
    old_pw: string,
    new_pw: string,
    new_pw_confirmation: string
  ): Observable<any> {
    let data: ChangePasswordModel = new ChangePasswordModel(
      undefined,
      undefined,
      old_pw,
      new_pw,
      new_pw_confirmation
    );
    return this.http
      .post(environment.api.base_api + APIRoutes.CHANGE_PASSWORD, data, {
        headers: this.httpHeaders,
      })
      .pipe(map((res: any) => res));
  }
}
